import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Introduction from "../pages/introduction/page";
import Register from "../pages/register/page";
import Process from "../pages/process/page";
import Essential from "../pages/essential/page";
import Document from "../pages/document/page";
import Review from "../pages/review/page";
import Faq from "../pages/faq/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import AdminCareRequest from "../pages/admin/care-request/page";
import AdminCareList from "../pages/admin/care-list/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminMatchList from "../pages/admin/match-list/page";
import CaregiverJob from "../pages/caregiver-job/page";

// ─── 매칭앱 페이지 ───
import AppEntry from "../pages/app/page";
import AppLogin from "../pages/app/login/page";
import AppRegister from "../pages/app/register/page";
import AppProfileEdit from "../pages/app/profile/edit/page";
import AppPatientHome from "../pages/app/patient/home/page";
import AppCaregiverHome from "../pages/app/caregiver/home/page";
import AppPatientSearch from "../pages/app/patient/search/page";
import AppCaregiverSearch from "../pages/app/caregiver/search/page";
import AppCaregiverDetail from "../pages/app/caregiver/detail/page";
import AppMatching from "../pages/app/matching/page";
import AppProfile from "../pages/app/profile/page";
import AppSelectRole from "../pages/app/select-role/page";
import AppAuthCallback from "../pages/app/auth/callback/page";
import AppRegisterPatient from "../pages/app/register-patient/page";
import AppRegisterCaregiver from "../pages/app/register-caregiver/page";
import AppPatientCareRequest from "../pages/app/care-request/page";
import AppFamilyCare from "../pages/app/family-care/page";
import AppInsuranceDoc from "../pages/app/insurance-doc/page";
import AppFaq from "../pages/app/faq/page";
import AppTerms from "../pages/app/terms/page";
import AppPrivacy from "../pages/app/privacy/page";
import AppNotificationSettings from "../pages/app/profile/notifications/page";
import AppNotifications from "../pages/app/notifications/page";
import AppReviewWrite from "../pages/app/review/write/page";
import AppMyReviews from "../pages/app/my-reviews/page";
import AppChat from "../pages/app/chat/page";
import AppChatList from "../pages/app/chat-list/page";
import AppCaregiverHistory from "../pages/app/caregiver/history/page";
import AppPatientHistory from "../pages/app/patient/history/page";
import AppMyCareRequests from "../pages/app/my-care-requests/page";
import AppCaregiverSchedule from "../pages/app/caregiver/schedule/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/introduction",
    element: <Introduction />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/process",
    element: <Process />,
  },
  {
    path: "/essential",
    element: <Essential />,
  },
  {
    path: "/document",
    element: <Document />,
  },
  {
    path: "/review",
    element: <Review />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/caregiver-job",
    element: <CaregiverJob />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/admin/care-request",
    element: <AdminCareRequest />,
  },
  {
    path: "/admin/care-list",
    element: <AdminCareList />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/match-list",
    element: <AdminMatchList />,
  },
  // ─── 매칭앱 라우트 ───
  {
    path: "/app",
    element: <AppEntry />,
  },
  {
    path: "/app/login",
    element: <AppLogin />,
  },
  {
    path: "/app/register",
    element: <AppRegister />,
  },
  {
    path: "/app/select-role",
    element: <AppSelectRole />,
  },
  {
    path: "/app/profile/edit",
    element: <AppProfileEdit />,
  },
  {
    path: "/app/profile/notifications",
    element: <AppNotificationSettings />,
  },
  {
    path: "/app/notifications",
    element: <AppNotifications />,
  },
  {
    path: "/app/patient/home",
    element: <AppPatientHome />,
  },
  {
    path: "/app/caregiver/home",
    element: <AppCaregiverHome />,
  },
  {
    path: "/app/patient/search",
    element: <AppPatientSearch />,
  },
  {
    path: "/app/caregiver/search",
    element: <AppCaregiverSearch />,
  },
  {
    path: "/app/matching",
    element: <AppMatching />,
  },
  {
    path: "/app/profile",
    element: <AppProfile />,
  },
  {
    path: "/app/caregiver/:id",
    element: <AppCaregiverDetail />,
  },
  {
    path: "/app/auth/callback",
    element: <AppAuthCallback />,
  },
  {
    path: "/app/register-patient",
    element: <AppRegisterPatient />,
  },
  {
    path: "/app/care-request",
    element: <AppPatientCareRequest />,
  },
  {
    path: "/app/register-caregiver",
    element: <AppRegisterCaregiver />,
  },
  {
    path: "/app/family-care",
    element: <AppFamilyCare />,
  },
  {
    path: "/app/insurance-doc",
    element: <AppInsuranceDoc />,
  },
  {
    path: "/app/faq",
    element: <AppFaq />,
  },
  {
    path: "/app/terms",
    element: <AppTerms />,
  },
  {
    path: "/app/privacy",
    element: <AppPrivacy />,
  },
  {
    path: "/app/review/write",
    element: <AppReviewWrite />,
  },
  {
    path: "/app/my-reviews",
    element: <AppMyReviews />,
  },
  {
    path: "/app/chat",
    element: <AppChat />,
  },
  {
    path: "/app/chat-list",
    element: <AppChatList />,
  },
  {
    path: "/app/caregiver/history",
    element: <AppCaregiverHistory />,
  },
  {
    path: "/app/patient/history",
    element: <AppPatientHistory />,
  },
  {
    path: "/app/my-care-requests",
    element: <AppMyCareRequests />,
  },
  {
    path: "/app/caregiver/schedule",
    element: <AppCaregiverSchedule />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;